import * as React from "react";

import "diff2html/bundles/css/diff2html.min.css";
import { Modal } from "@impero-com/ui";

import { GhLikeDiff } from "./ghLikeDiff";

interface DiffViewProps {
    name: string;
    previous: string | undefined;
    current: string | undefined;
}

class DiffView extends React.PureComponent<DiffViewProps> {
    render() {
        const { current, previous } = this.props;
        // We replace spaces by non-breaking spaces, to prevent misidentification by diff2html
        const name = this.props.name.replace(/ /g, "\xA0");
        return (
            <GhLikeDiff
                options={{
                    outputFormat:
                        !previous || !current ? "line-by-line" : "side-by-side", // 'line-by-line' or 'side-by-side'
                    maxLineLengthHighlight: 1000,
                    renderNothingWhenEmpty: true,
                    matchWordsThreshold: 0.25,
                    matchingMaxComparisons: 2500,
                    maxLineSizeInBlockForComparison: 200,
                    diffMaxLineLength: 10000,
                    drawFileList: false,
                }}
                current={current}
                previous={previous}
                name={name}
            />
        );
    }
}

class DiffOpener extends React.Component<DiffOpenerProps, DiffOpenerState> {
    state: DiffOpenerState = { open: false };

    render() {
        const { name, title, previous, current, children } = this.props;
        if (!previous && !current) {
            return <>{children}</>;
        }

        const previousPretty = previous
            ? JSON.stringify(previous, null, 2)
            : undefined;
        const currentPretty = current
            ? JSON.stringify(current, null, 2)
            : undefined;

        return (
            <>
                <a title={title} onClick={() => this.setState({ open: true })}>
                    {children}
                </a>
                <Modal
                    variant="content"
                    open={this.state.open}
                    onClose={() => this.setState({ open: false })}
                    title={title}
                    width="90%"
                    scrollBody={false}
                >
                    <DiffView
                        name={name}
                        previous={previousPretty}
                        current={currentPretty}
                    />
                </Modal>
            </>
        );
    }
}

interface DiffOpenerState {
    open: boolean;
}

interface DiffOpenerProps {
    name: string;
    title: string;
    previous?: object | null;
    current?: object | null;
    children: React.ReactNode;
}

export { DiffView, DiffOpener };
